import nssiCoverages from "@/assets/nssi_coverages.json";
import nssiDeductibles from "@/assets/nssi_deductibles.json";
import { Defaults } from "@/models/Defaults";
import { Quote } from "@/models/Quote";
import axios from "axios";
import { calculateQuoteNssi, formatNssiCoverageAmount } from "@/utils/Utils";
import { PaymentOptions } from "@/models/QuoteInsurance";
import { cardTypeShort } from "@/utils/Utils";
import { User } from "@/models/User";
import { BillingAddressType } from "@/models/PaymentMethod";
import { DateTimeFormatter, LocalDate } from "@js-joda/core";
import instanceAxios from "./axiosInst";
//import store from "@/store/index";
import ProductService from "@/services/ProductService";
import Product from "@/models/Product";

export class NssiData {
  static get coverages() {
    return nssiCoverages;
  }

  static get deductibles() {
    return nssiDeductibles;
  }

  /**
   * Gets NSSI rates from server
   * @param quote Current quote to get the rates for
   */
  static async getRates(
    quote: Quote
  ): Promise<{ error: boolean; message: string; result: any }> {
    const result = {
      error: false,
      message: "",
      result: [],
    };

    const query = {
      promocode: Defaults.getInstance().nssiPromoCode,
      policyState: quote.address.state.short,
      userType: Defaults.getInstance().nssiUserType,
      productCode: Defaults.getInstance().nssiProductCode,
      classCode: Defaults.getInstance().nssiClassCode,
      deductible: quote.personalInsurance.deductibleAmount,
      coverageAmount: formatNssiCoverageAmount(
        quote.personalInsurance.coverageAmount
      ),
      coverageType: Defaults.getInstance().nssiCoverageType,
    };
    let response;
    try {
      response = await axios.post(
        process.env.VUE_APP_MAGENTO_URL + "/rest/V1/NSSI/wise/rates",
        query
      );
    } catch (error) {
      result.error = true;
      result.message = "Unknown error";
    }
    result.result = response?.data;
    return new Promise<{ error: boolean; message: string; result: any }>(
      (resolve) => {
        resolve(result);
      }
    );
  }
  /**
   * Get school cities for a specific state
   * @param quote Current quote
   * @returns
   */
  static async getCities(
    quote: Quote
  ): Promise<{ error: boolean; message: string; result: any }> {
    const result = {
      error: false,
      message: "",
      result: [],
    };
    const query = {
      sku: quote.personalInsurance.sku,
      state: quote.address.state.short,
    };
    if (
      quote.personalInsurance.sku == " " ||
      quote.address.state.short == " "
    ) {
      result.error = true;
      result.message = "Error loading sku or state";
    }
    let response;
    try {
      response = await axios.post(
        process.env.VUE_APP_MAGENTO_URL + "/rest/V1/NSSI/wise/cities",
        query
      );
    } catch (error) {
      result.error = true;
      result.message = "Unknown error";
    }
    result.result = response?.data;

    return new Promise<{ error: boolean; message: string; result: any }>(
      (resolve) => {
        resolve(result);
      }
    );
  }
  /**
   * Gets the schools fopr a specific city
   * @param quote
   * @returns
   */
  static async getSchoolsByCity(
    quote: Quote
  ): Promise<{ error: boolean; message: string; result: any }> {
    const result = {
      error: false,
      message: "",
      result: [],
    };
    const query = {
      sku: quote.personalInsurance.sku,
      state: quote.address.state.short,
      city: quote.checkout.schoolCity,
    };
    let response;
    try {
      response = await axios.post(
        process.env.VUE_APP_MAGENTO_URL + "/rest/V1/NSSI/wise/schools",
        query
      );
    } catch (error) {
      result.error = true;
      result.message = "Unknown error";
    }
    result.result = response?.data;

    return new Promise<{ error: boolean; message: string; result: any }>(
      (resolve) => {
        resolve(result);
      }
    );
  }
  /**
   * Issues new NSSI policy
   * @param quote
   */
  static async issuePolicy(
    quote: Quote,
    userM2: any,
    cartId: any
  ): Promise<{ error: boolean; message: string; policy: number }> {
    const result = {
      error: false,
      message: "",
      policy: 0,
    };
    if (!quote.hasPersonalInsurance) {
      result.message = "No personal insurance";
    } else {
      //ova treb dz oznacis kako ok
      //if(!user.addresses.length) {
      //  throw new Error("User has no address defined.");
      //}
      const data = await this.prepareApiData(quote, userM2, cartId);
      try {
        const response = await instanceAxios.post(
          process.env.VUE_APP_MAGENTO_URL +
            "/rest/portal/V1/carts/mine/payment-information",
          data
        );
        result.error = false;
        result.message = "";
        if (
          response.data.Errors &&
          Array.isArray(response.data.Errors) &&
          response.data.Errors.length > 0
        ) {
          result.message = response.data.Errors[0].Message;
        }
        if (!isNaN(response["data"])) {
          result.policy = parseInt(response["data"]);
        } else {
          throw "Is not a number";
        }
      } catch (error: any) {
        result.error = true;
        result.message = "api failed, but issue successful:" + error.message;
      }
      //quote.personalInsurance.hasPaymentErrors = !response.data.PaymentSuccess;
    }
    return new Promise<{ error: boolean; message: string; policy: any }>(
      (resolve) => {
        resolve(result);
      }
    );
  }
  /**
   * Prepare data for sending to WAG API.
   */
  static async prepareApiData(quote: Quote, user: User, cartId: string) {
    // policies.push(policyItem);
    const address = this.getBillingAddress(quote);
    const userDataAll = await this.getUserData();
    const addressInfo = await this.countryId(address.state.title);
    const body = {
      cartId: cartId,
      billingAddress: {
        countryId: addressInfo?.state,
        regionId: addressInfo?.id,
        regionCode: address.state.short,
        region: address.state.title,
        customerId: userDataAll.customer.id,
        street: [address.address + " " + address.streetNumber],
        company: null,
        fax: null,
        telephone: quote.checkout.info.phone,
        postcode: address.zip,
        city: address.city,
        firstname: address.firstName,
        lastname: address.lastName,
        middlename: null,
        prefix: null,
        suffix: null,
        vatId: null,
        email: quote.checkout.info.email,
        customAttributes: [],
        saveInAddressBook: null,
      },
      paymentMethod: {
        method: "wise_payment",
        additional_data: {
          po_number: "string",
          cc_cid: quote.checkout.paymentMethod.cvv,
          cc_ss_start_month: "",
          cc_ss_start_year: "",
          cc_ss_issue: "",
          cc_type: cardTypeShort(quote.checkout.paymentMethod.cardNumber),
          cc_exp_year: quote.checkout.paymentMethod.expDateYear,
          cc_exp_month: quote.checkout.paymentMethod.expDateMonth,
          cc_number: quote.checkout.paymentMethod.cardNumber,
          captcha_string: null,
        },
        extension_attributes: {
          agreement_ids: ["1"],
        },
      },
    };
    return body;
  }

  static getPolicyWagType(type: PaymentOptions): string {
    if (type === PaymentOptions.Annual) {
      return "Annual";
    } else {
      return "Installment";
    }
  }

  static getBillingAddress(quote: Quote) {
    if (
      quote.checkout.paymentMethod.billingAddressType ==
      BillingAddressType.Property
    ) {
      return quote.address;
    } else if (
      quote.checkout.paymentMethod.billingAddressType ==
      BillingAddressType.Mailing
    ) {
      if (quote.checkout.useSameAddressForMailing) {
        return quote.address;
      } else {
        return quote.checkout.mailingAddress;
      }
    } else if (
      quote.checkout.paymentMethod.billingAddressType ==
      BillingAddressType.Different
    ) {
      return quote.checkout.paymentMethod.billingAddress;
    } else {
      return quote.address;
    }
  }
  //empty basket
  /**
   * Add all items from local cart to remote.
   * @param quote
   */
  static async toRemote(quote: Quote): Promise<number> {
    let id = 0;
    try {
      const remoteQuote = await this.getQuote();

      // First delete any existing cart items on remote side
      if (remoteQuote) {
        id = remoteQuote.id;
        await this.deleteRemoteQuoteItems();
      } else {
        //Create new cart if not exist
        const response = await instanceAxios.post(
          process.env.VUE_APP_MAGENTO_URL + "/rest/portal/V1/carts/mine",
          {}
        );
        id = response.data;
      }
      //TODO item need to be in vuex Quote Addon
      //Ok, now add quote items
      const item: any = {
        PolicyItems: [
          {
            CoverageAmount: quote.personalInsurance.coverageAmount,
            ItemManufacturer: "Property",
            ItemModel: "Property",
            SerialNumber: "Property",
          },
        ],
        EffectiveDate: LocalDate.now()
          .plusDays(1)
          .format(DateTimeFormatter.ofPattern("M/d/yyyy")),
        ProductSKU: quote.personalInsurance.sku,
        ProcessingFeeSKU: quote.personalInsurance.processingFeeSku,
        PolicyType: this.getPolicyWagType(
          quote.personalInsurance.paymentOption
        ),
        PaymentTerm: quote.personalInsurance.paymentOption,
        PolicyTermValue: "1",
        IsMonthly: this.isMonthly(quote.personalInsurance.paymentOption),
        RetailPremium: quote.personalInsurance.retailPremium.toFixed(2),
        BillToRoleType: Defaults.getInstance().nssiBillToRoleType,
        LeadType: Defaults.getInstance().nssiLeadType,
        State: quote.address.state.short,
        Interest_Magento_entity_id: null,
        company: Defaults.getInstance().nssiPaymentCompany,
        CustomerID: Defaults.getInstance().nssiCustomerId,
        MethodType: Defaults.getInstance().nssiPaymentMethodType,
        PaymentAmount: calculateQuoteNssi(quote).toFixed(2),
        CoverageType: Defaults.getInstance().nssiCoverageType,
        PolicyLenght: Defaults.getInstance().policyLength,
        UserType: Defaults.getInstance().nssiUserType,
        PersonalInsurance: quote.personalInsurance,
        AllInfo: quote.info,
        RentersInsurance: quote.rentersInsurance,
        FBO: {
          FirstName: quote.checkout.info.firstName,
          LastName: quote.checkout.info.lastName,
          Address1: quote.address.address,
          Address2: "",
          City: quote.address.city,
          State: quote.address.state.short,
          Zip: quote.address.zip,
          Phone: quote.checkout.info.phone,
          Email: quote.checkout.info.email,
        },
      };
      if (item.PersonalInsurance.retailPremium) {
        await this.addCartItem(item, quote, id);
      }

      // await Promise.all(quote.items.map(async item => {
      //await this.addCartItem(item, quote, id);
      //   })
      // );
    } catch (error) {
      throw "Something went wrong with adding chart item";
    }
    return id;
  }
  /**
   * Gets current cart or null if none
   */
  private static async getQuote(): Promise<any> {
    try {
      // Get cart information
      const cartInfoResp = await instanceAxios.get(
        process.env.VUE_APP_MAGENTO_URL + "/rest/portal/V1/carts/mine"
      );
      return cartInfoResp.data;
    } catch (error) {
      return null;
    }
  }
  /**
   * Delete cart items from remote.
   */
  private static async deleteRemoteQuoteItems(): Promise<void> {
    try {
      await instanceAxios.delete(
        process.env.VUE_APP_MAGENTO_URL +
          "/rest/portal/V1/WAG/carts/mine/delete-all"
      );
    } catch (error) {
      throw "Something went wrong with deleting items";
    }
  }
  private static async addCartItem(
    item: any,
    quote: any,
    quote_id: number
  ): Promise<void> {
    try {
      //TODO this need to go to QuoteAddon and in vuex
      // First, get the product for this cart item
      const products = await ProductService.all();
      // const product = products.find(p => {
      //     return p.classcode == item.PolicyType.toString();
      // });
      // Configure product options
      const itemOptions = this.configureCustomizableOptions(
        item,
        quote,
        products[0]
      );

      const body = {
        cartItem: {
          sku: products[0] ? products[0].main_sku : "",
          qty: 1,
          quote_id: quote_id,
          product_option: {
            extension_attributes: {
              custom_options: itemOptions,
            },
          },
          extension_attributes: {},
        },
      };

      await instanceAxios.post(
        process.env.VUE_APP_MAGENTO_URL + "/rest/portal/V1/carts/mine/items",
        body
      );
    } catch (error) {
      throw "Something went wrong with adding item to chart";
    }
  }
  private static configureCustomizableOptions(
    item: any,
    _quote: Quote,
    product?: Product
  ): any[] {
    const itemOptions: any[] = [];
    if (!product || !product.customizable_options) {
      throw new Error("Product cannot be found.");
    }
    product.customizable_options.forEach((option) => {
      switch (option.title) {
        case "City":
          itemOptions.push({
            option_id: option.id,
            option_value: item.FBO.City,
          });
          break;
        case "First Name":
          itemOptions.push({
            option_id: option.id,
            option_value: item.FBO.FirstName,
          });
          break;
        case "Installment Premium":
          itemOptions.push({
            option_id: option.id,
            option_value: item.PersonalInsurance.installmentAmount,
          });
          break;
        case "Last Name":
          itemOptions.push({
            option_id: option.id,
            option_value: item.FBO.LastName,
          });
          break;
        //TODO: check what to do with portal id
        // case "Portal Id":
        //   itemOptions.push({
        //     option_id: option.id,
        //     option_value: "Portal"
        //   });
        //   break;
        case "School":
          itemOptions.push({
            option_id: option.id,
            option_value: _quote.checkout.schoolName,
          });
          break;
        case "School Key":
          itemOptions.push({
            option_id: option.id,
            option_value: _quote.checkout.schoolKey,
          });
          break;
        case "price":
          itemOptions.push({
            option_id: option.id,
            option_value: item.PersonalInsurance.retailPremium, // TODO: Check if this value should be here? Should this be formatted toCurrency?
          });
          break;
        case "sku":
          itemOptions.push({
            option_id: option.id,
            option_value: item.ProductSKU,
          });
          break;
        case "Product Name":
          itemOptions.push({
            option_id: option.id,
            option_value: product.name,
          });
          break;
        case "Promocode":
          itemOptions.push({
            option_id: option.id,
            option_value: product.promo_code,
          });
          break;
        case "State":
          itemOptions.push({
            option_id: option.id,
            option_value: item.State,
          });
          break;
        case "Product Code":
          itemOptions.push({
            option_id: option.id,
            option_value: product.product_code,
          });
          break;
        case "User Type":
          itemOptions.push({
            option_id: option.id,
            option_value: "Virtual",
          });
          break;
        case "Coverage Amount":
          itemOptions.push({
            option_id: option.id,
            option_value: item.PersonalInsurance.coverageAmount,
          });
          break;
        case "Coverage Type Value":
          itemOptions.push({
            option_id: option.id,
            option_value: "Full Coverage",
          });
          break;
        case "Coverage Type":
          itemOptions.push({
            option_id: option.id,
            option_value: item.PolicyType,
          });
          break;
        case "Deductible":
          itemOptions.push({
            option_id: option.id,
            option_value: item.PersonalInsurance.deductibleAmount,
          });
          break;
        case "Policy Term":
          itemOptions.push({
            option_id: option.id,
            //option_value: item.PolicyTermValue + " Year" //1,2,3
            option_value: "1 Year",
          });
          break;
        case "Payment Term Value":
          itemOptions.push({
            option_id: option.id,
            option_value:
              item.PaymentTerm == PaymentOptions.Monthly ? "monthly" : "yearly", //monthly = 1, yearly-renew = 3, yearly = 2
          });
          break;
        case "Payment Term":
          itemOptions.push({
            option_id: option.id,
            option_value: item.PaymentTerm,
          });
          break;
        case "Is Monthly":
          itemOptions.push({
            option_id: option.id,
            option_value: item.IsMonthly,
          });
          break;
        case "Fee Sku":
          itemOptions.push({
            option_id: option.id,
            option_value: item.ProcessingFeeSKU,
          });
          break;
        case "Fee":
          itemOptions.push({
            option_id: option.id,
            option_value: item.RentersInsurance.serviceFee,
          });
          break;
      }
    });
    return itemOptions;
  }
  static isMonthly(item: any) {
    if (item == PaymentOptions.Monthly) {
      return "true";
    } else {
      return "false";
    }
  }
  static async getUserData() {
    try {
      // Get cart information
      const cartInfoResp = await instanceAxios.get(
        process.env.VUE_APP_MAGENTO_URL + "/rest/portal/V1/carts/mine"
      );
      return cartInfoResp.data;
    } catch (error) {
      return null;
    }
  }

  static async getAllCountries() {
    const response = await instanceAxios.get(
      process.env.VUE_APP_MAGENTO_URL + "/rest/V1/NSSI/countries"
    );
    return response.data;
  }

  static async countryId(item: any) {
    const allCountries = await this.getAllCountries();
    const countryName = item;
    let US;
    let CA;
    if (allCountries.US) {
      US = allCountries.US.filter((state: { title: any; id: number }) => {
        if (state.title == countryName) return state.id;
      });
    }
    if (allCountries.CA) {
      CA = allCountries.CA.filter((state: { title: any; id: number }) => {
        if (state.title == countryName) return state.id;
      });
    }
    if (US.length > 0) {
      return { state: "US", id: US[0].id };
    } else if (CA.length > 0) {
      return { state: "CA", id: CA[0].id };
    } else {
      console.log("No countries matching");
    }
  }
}
